import React, { useEffect, useState } from 'react';
import { material } from '../../../library/material';
import { getCrmNotesData } from '../../../services/PlatformCrmService';
import Snackbar from '../../toastrmessage/Snackbar';
import { StyledTableCell } from '../../../shared/TableHeaderStyle';
import AddNotesDialog from './AddNotesDialog';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import moment from 'moment';

const localDataFormate = (date) => {
    const localTime = moment.utc(date).toDate();
    const dateFormate = moment(localTime).format('YYYY-MM-DD HH:mm');
    return dateFormate;
};

function ViewNotesDialog(props) {

    const { openNotesDialog, setOpenNotesDialog } = props;
    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });
    const [notesData, setNotesData] = useState([]);
    const [openAddNotesDialog, setOpenAddNotesDialog] = useState({ action: false, platformCrmId: null });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (openNotesDialog.action) {
            getNotesDataByPlatformCrmId();
        }
    }, [openNotesDialog.action]);

    const getNotesDataByPlatformCrmId = () => {
        setIsLoading(true);
        getCrmNotesData(openNotesDialog.rowData.platformCrmId)
            .then((resp) => {
                setNotesData(resp.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.data.info,
                    })
                } else {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.data || error.response.data.messages,
                    })
                }
            })
    };

    const addNote = () => {
        setOpenAddNotesDialog({ action: true, platformCrmId: openNotesDialog.rowData.platformCrmId });
    };

    const handleClose = () => {
        setOpenNotesDialog({ action: false, rowData: null })
    };

    return (
        <div>
            <material.Dialog open={openNotesDialog.action} maxWidth="xl" fullWidth hideBackdrop>
                <material.DialogTitle>CRM Notes
                    <span className='float-end'>
                        <material.Button variant="contained" sx={{ textTransform: "none", mr: 1 }} size='small' onClick={addNote} startIcon={<material.AddIcon />}>Add Note</material.Button>
                        <material.Button variant="contained" sx={{ textTransform: "none" }} color='error' size='small' onClick={handleClose} startIcon={<material.CloseIcon />}>Close</material.Button>
                    </span>
                </material.DialogTitle>
                <material.DialogContent>
                    <material.TableContainer>
                        <material.Table>
                            <material.TableHead >
                                <material.TableRow>
                                    <StyledTableCell>User Name</StyledTableCell>
                                    <StyledTableCell>Notes</StyledTableCell>
                                    <StyledTableCell>Created Date</StyledTableCell>
                                </material.TableRow>
                            </material.TableHead>
                            <material.TableBody>
                                {isLoading ? (
                                    <material.TableRow >
                                        <material.TableCell colSpan={10}>
                                            <SkeletonTheme baseColor="#bbdefb" highlightColor="#c6ff00" enableAnimation="true" inline="true" width="100% " height="30px">
                                                <Skeleton count={10} />
                                            </SkeletonTheme>
                                        </material.TableCell>
                                    </material.TableRow>
                                ) : (
                                    <>
                                        {notesData.length ? notesData.map((rowData, k) => (
                                            <material.TableRow key={k}>
                                                <material.TableCell>{rowData.userName}</material.TableCell>
                                                <material.TableCell sx={{ maxWidth: 500 }}>{rowData.notes}</material.TableCell>
                                                <material.TableCell>{localDataFormate(rowData.createdAt)}</material.TableCell>
                                            </material.TableRow>
                                        )) : (
                                            <material.TableRow>
                                                <material.TableCell colSpan={3}>
                                                    <h6 className='d-flex justify-content-center text-danger fw-bold'>No data found</h6>
                                                </material.TableCell>
                                            </material.TableRow>
                                        )}
                                    </>
                                )}
                            </material.TableBody>
                        </material.Table>
                    </material.TableContainer>
                </material.DialogContent>
            </material.Dialog>
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
            <AddNotesDialog
                openAddNotesDialog={openAddNotesDialog}
                setOpenAddNotesDialog={setOpenAddNotesDialog}
                getNotesDataByPlatformCrmId={getNotesDataByPlatformCrmId}
            />
        </div>
    );
}

export default ViewNotesDialog;